import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, IconMessage, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'
import { OrderedList, ListItem } from 'components/list'
import { CheckCircleFilled as Success } from 'components/feather'

const WebhookSupportedFeatures = () => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_supported_features"
                defaultMessage="Supported features" />
        </Heading>
        <OrderedList>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_export_state"
                                    defaultMessage="Export current state of user profiles" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_export_state"
                                defaultMessage="To initialize, or refresh, state for the system connecting by webhook, exporting will send all supported profile data for each employee." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_receive_updates"
                                    defaultMessage="Automatically receive real-time updates when a profile is changed in Huma" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_receive_updates"
                                defaultMessage="Changes made in the supported profile fields (listed below) will be automatically sent as updates to the URL registered." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_automated_updates"
                                    defaultMessage="Automated updates when users are added or removed" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_automated_updates"
                                defaultMessage="Whenever a user is created or deleted in Huma, a message is automatically sent to the URL registered." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_automated_updates_groups"
                                    defaultMessage="Team and Location updates" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_automated_updates_groups"
                                defaultMessage="Whenever a team or location is created, updated or deleted in Huma, a message is automatically sent to the URL registered." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_automated_updates_absence"
                                    defaultMessage="Automated updates when absences are registered or removed" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_automated_updates_absence"
                                defaultMessage="Whenever an absence is registered or removed, a message is automatically sent to the URL registered." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph className="compact">
                            <strong>
                                <FormattedMessage
                                    id="integration_webhook_feature_heading_receive_updates_absence"
                                    defaultMessage="Receive real-time updates when an absence entry is reviewed, or is otherwise edited in Huma" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_webhook_feature_text_receive_updates_absence"
                                defaultMessage="Most commonly, updates will be sent when absence requests are accepted or rejected, but changing the requested dates, editing the explanatory note, or any other change will also cause updates to be sent to the URL registered." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
        </OrderedList>
    </Section>
)

export default WebhookSupportedFeatures